import React, { useState, useMemo } from "react";
// import queryString from "query-string";
import { Form } from "formsy-react-components";
// import ReportService from "../../../services/reportService";
import DepartmentSelect from "../../common/DepartmentSelect";
import { formatDate } from "../../../helpers/date";

import "./ResourceSummaryPage.scss";

const ResourceSummaryPage = () => {
  const [department, setDepartment] = useState("");
  // commented out data/set data since fetch was not being used. (EBW)
  // const [data, setData] = useState("");

  const period = useMemo(() => {
    const today = new Date();
    const todayAtMidnight = new Date(today.setHours(0, 0, 0, 0));
    const lastMonday = new Date(
      todayAtMidnight.setDate(
        todayAtMidnight.getDate() - ((todayAtMidnight.getDay() + 6) % 7)
      )
    );
    return `${formatDate(lastMonday, "MM/dd/yyyy")} - ${formatDate(
      today,
      "MM/dd/yyyy"
    )}`;
  }, []);

  // const fetchData = useCallback(async () => {
  //   const query = queryString.stringify(
  //     {
  //       department
  //     },
  //     { arrayFormat: "bracket" }
  //   );
  //   const result = await ReportService.get(`/resource-summary?${query}`);
  //   setData(result.data);
  // }, [department]);

  return (
    <Form>
      <div className="report-page">
        <div className="header-report-container">
          <div className="col-md-3">
            <h1>Resource Summary Report</h1>
          </div>
          <div className="col-md-3 field">
            <DepartmentSelect
              value={department}
              onChange={(dep) => setDepartment(dep)}
            />
          </div>
          <div className="col-md-3 field">
            <input
              disabled
              name="period"
              type="text"
              className="form-control date-period-field"
              value={period}
            />
            {/* <Input disabled name="period" value={period} /> */}
          </div>
          <br />
        </div>
      </div>
    </Form>
  );
};
export default ResourceSummaryPage;
